import moment from "moment-timezone";

export default (timestamp, inputFormat, outputFormat) => 
    moment(timestamp,inputFormat).format(outputFormat)
